import { FileModel } from '@/types';
import { Tooltip } from 'antd';
import { FC } from 'react';

type FormUpdateAltPropsTypes = {
  imageInfo: FileModel;
  name?: string;
};

const FileItemInfo: FC<FormUpdateAltPropsTypes> = ({ imageInfo, name }) => {
  const { alt, type } = imageInfo;
  return (
    <>
      <div className="uploaded-image__update-alt">
        <Tooltip placement="top" title={name}>
          {!!name && <p className="uploaded-image__name">{name}</p>}
        </Tooltip>

        {!!type && (
          <div className="uploaded-image__file-type-wrapper">
            <p className="uploaded-image__file-type">{type}</p>
          </div>
        )}
      </div>
      <div className="uploaded-image__update-alt">
        <Tooltip title={alt}>
          <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            Alt: {alt}
          </span>
        </Tooltip>
      </div>
    </>
  );
};

export default FileItemInfo;
